import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    root: {
      display: 'inline-flex',
    },
    treeView: {
      maxHeight: theme.spacing(30),
      overflow: 'auto',
      padding: theme.spacing(0.5, 1),
      '& ul.k-content': {
        padding: 0,
      },
    },
  };
};
